export const getMediaUrl = (url) => {
  if (!url) return "";
  
  // If the URL contains "http" (e.g. new CloudFront URL), extract and return it as is,
  // bypassing any prefixes the backend might have incorrectly prepended (like undefined/undefined/
  // or a doubled bucket path wrapping an already-full URL). Use the LAST occurrence so a
  // prefix that itself starts with "http" (e.g. the GCS bucket base URL) doesn't short-circuit
  // the strip and leave the wrapping prefix in place.
  const httpIndex = url.lastIndexOf("http");
  if (httpIndex !== -1) {
    return url.substring(httpIndex);
  }
  
  // Otherwise, it's a legacy file on Google Cloud Storage, so prepend the bucket path.
  return `https://storage.googleapis.com/tz-bucket-0/${url}`;
};
